import React from "react";
import FooterOneAr from "../Footer/FooterOneAr";
import Header from "../Header/HeaderTwo";
import { pageTitle } from "../PageTitle";

const ServicesDetailsAr = () => {
  pageTitle("Services Details");
  return (
    <>
      <Header></Header>

      <div className="services__details section-padding">
        <div className="container" dir="rtl">
          <div className="row">
            <div className="col-xl-12 col-lg-8">
              <div className="services__details-left">
                <div
                  className="services__details-left-content mb-40"
                  style={{ paddingTop: "13%" }}
                >
                  <div className="contact__area-title">
                    <span className="subtitle">الشروط والأحكام</span>
                  </div>
                  <p style={{ marginBottom: "1.5rem" }}>
                    مرحبًا بك في تطبيق Euphoria Group! توضح هذه الشروط والأحكام
                    القواعد واللوائح التي تحكم استخدامك للتطبيق. باستخدامك
                    للتطبيق، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا
                    توافق، يرجى عدم استخدام التطبيق.
                  </p>

                  <h4>الخدمات المقدمة :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    يتيح تطبيق Euphoria Group للمستخدمين:
                    <ul>
                      <li className="mt-2">
                        عرض الوحدات السكنية/العقارية المشتراة.
                      </li>
                      <li className="mt-2">
                        الوصول إلى الأسعار، والمبالغ المستحقة، ومواعيد السداد.
                      </li>
                      <li className="mt-2">
                        التواصل مع فريق الدعم عبر الدردشة.
                      </li>
                      <li className="mt-2">
                        عرض العروض التسويقية والخدمات الأخرى.
                      </li>
                    </ul>
                  </p>

                  <h4>تسجيل الحساب :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        لا يمكن للمستخدمين إنشاء حساباتهم بأنفسهم؛ الشركة هي
                        المسؤولة عن إنشاء وتوفير الحسابات للمستخدمين.
                      </li>
                      <li className="mt-2">
                        المستخدمون مسؤولون عن جميع الأنشطة التي تتم من خلال
                        حساباتهم.
                      </li>
                    </ul>
                  </p>

                  <h4>بيانات المستخدم والخصوصية :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        قد يقوم التطبيق بجمع معلومات شخصية مثل الأسماء وتفاصيل
                        الاتصال لتقديم الخدمات.
                      </li>
                      <li className="mt-2">
                        تتم جميع عمليات جمع البيانات واستخدامها وفقًا للوائح
                        حماية البيانات المعمول بها، بما في ذلك GDPR وCCPA إن
                        أمكن.
                      </li>
                      <li className="mt-2">
                        يمكن للمستخدمين طلب الوصول إلى بياناتهم أو حذفها عن طريق
                        التواصل مع الشركة من خلال القنوات الرسمية.
                      </li>
                      <li className="mt-2">
                        لا يشارك التطبيق بيانات المستخدم الشخصية مع أطراف ثالثة
                        إلا عند الضرورة التشغيلية أو القانونية.
                      </li>
                    </ul>
                  </p>

                  <h4>الأسعار والمدفوعات :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        تعكس جميع الأسعار المدرجة في التطبيق أسعار الوحدات
                        المشتراة وليست متاحة للبيع.
                      </li>
                      <li className="mt-2">
                        يُطلب من المستخدمين دفع المبالغ المستحقة وفقًا لجدول
                        الدفع المعروض في التطبيق.
                      </li>
                      <li className="mt-2">
                        تحتفظ شركة Euphoria Group بالحق في إلغاء أو تعديل أي طلب
                        بناءً على الظروف التشغيلية.
                      </li>
                      <li className="mt-2">
                        تُعالج معلومات الدفع بشكل آمن، والمستخدمون مسؤولون عن
                        التأكد من سداد المدفوعات في الوقت المناسب.
                      </li>
                    </ul>
                  </p>

                  <h4>التواصل مع الدعم :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        يمكن للمستخدمين التواصل مع فريق الدعم من خلال خاصية
                        الدردشة داخل التطبيق.
                      </li>
                      <li className="mt-2">
                        يجب على المستخدمين عدم إساءة استخدام خاصية الدردشة أو
                        إرسال رسائل غير لائقة أو القيام بأي نوع من المضايقات.
                      </li>
                    </ul>
                  </p>

                  <h4>المحتوى والإعلانات :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        قد يحتوي التطبيق على إعلانات وعروض ترويجية تتعلق بخدمات
                        شركة Euphoria Group.
                      </li>
                      <li className="mt-2">
                        تحتفظ الشركة بالحق في إرسال إشعارات تسويقية إلى
                        المستخدمين.
                      </li>
                      <li className="mt-2">
                        يمكن للمستخدمين إلغاء الاشتراك في الإشعارات التسويقية من
                        خلال إعدادات التطبيق أو بالتواصل مع الدعم.
                      </li>
                    </ul>
                  </p>

                  <h4>حقوق الملكية الفكرية :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        جميع المحتويات والتصاميم والعلامات التجارية في التطبيق
                        هي ملكية حصرية لشركة Euphoria Group.
                      </li>
                      <li className="mt-2">
                        يُمنع نسخ أو إعادة نشر أي جزء من التطبيق دون إذن كتابي
                        مسبق.
                      </li>
                    </ul>
                  </p>

                  <h4>إخلاء المسؤولية :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        لا تتحمل Euphoria Group مسؤولية أي أخطاء أو تأخيرات في
                        تحديث الأسعار أو المعلومات الأخرى.
                      </li>
                      <li className="mt-2">
                        يُوفر التطبيق معلومات إرشادية فقط، وتقع مسؤولية اتخاذ أي
                        قرارات مالية أو شرائية على المستخدم.
                      </li>
                      <li className="mt-2">
                        لا تضمن الشركة استمرار الخدمة دون انقطاع، ولا تتحمل
                        المسؤولية عن أي مشكلات تقنية خارجة عن إرادتها.
                      </li>
                    </ul>
                  </p>

                  <h4>تعديلات الشروط :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        تحتفظ شركة Euphoria Group بالحق في تعديل هذه الشروط
                        والأحكام في أي وقت.
                      </li>
                      <li className="mt-2">
                        سيتم إخطار المستخدمين بأي تحديثات مهمة عبر التطبيق أو
                        البريد الإلكتروني.
                      </li>
                    </ul>
                  </p>

                  <h4>سياسة حذف البيانات :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        يمكن للمستخدمين طلب حذف حساباتهم وبياناتهم المرتبطة من
                        خلال التواصل مع الدعم عبر التطبيق أو البريد الإلكتروني.
                      </li>
                      <li className="mt-2">
                        ستقوم شركة Euphoria Group بمعالجة طلبات حذف البيانات
                        وفقًا للقوانين واللوائح المعمول بها.
                      </li>
                    </ul>
                  </p>

                  <h4>القانون المُنظم :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        تخضع هذه الشروط والأحكام لقوانين الدولة التي تعمل بها
                        شركة Euphoria Group.
                      </li>
                      <li className="mt-2">
                        يتم حل أي نزاعات تنشأ من خلال الجهات القضائية المختصة.
                      </li>
                    </ul>
                  </p>

                  <h4>تواصل معنا :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    إذا كان لديك أي استفسارات بخصوص هذه الشروط، يمكنك التواصل
                    معنا عبر:
                    <ul>
                      <li className="mt-2">خاصية الدردشة داخل التطبيق.</li>
                      <li className="mt-2">
                        البريد الإلكتروني الرسمي للشركة:
                        <a href="mailto:Support@euphoriagroup.com.eg">
                          {" "}
                          Support@euphoriagroup.com.eg
                        </a>
                      </li>
                      <li className="mt-2">
                        موقعنا الرسمي :
                        <a
                          href="https://euphoriagroup.com.eg"
                          target="_blank"
                          className="text-lowercase"
                        >
                          {" "}
                          www.euphoriagroup.com.eg
                        </a>
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOneAr></FooterOneAr>
    </>
  );
};

export default ServicesDetailsAr;
